import { useState, useEffect } from "react";

const SHOW_AFTER_MS = 3 * 60 * 1000; // 3 minutes

export default function MoveOutOfAiAnalysisButton({
  createdAt,
  onMoveToReverify,
}) {
  const [canShow, setCanShow] = useState(false);

  useEffect(() => {
    if (!createdAt) {
      setCanShow(false);
      return;
    }

    const elapsed = Date.now() - new Date(createdAt).getTime();
    const remaining = SHOW_AFTER_MS - elapsed;

    if (remaining <= 0) {
      setCanShow(true);
      return;
    }

    setCanShow(false);
    const timer = setTimeout(() => setCanShow(true), remaining);
    return () => clearTimeout(timer);
  }, [createdAt]);

  if (!canShow) return null;

  return (
    <div
      className="absolute top-1 right-10 text-xs font-medium border border-solid border-[#017C57] px-4 py-2 rounded-full cursor-pointer"
      onClick={onMoveToReverify}
    >
      Move Out Of AI Analysis
    </div>
  );
}
